// extracted by mini-css-extract-plugin
module.exports = {"header":"vault-grid_header__euQYN","cards":"vault-grid_cards__Q6xf8","body":"vault-grid_body__NHOXd"};